// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kIF4l","right":"styles_right__3Gb4g"};